<template>
  <div id="saved-tables">
    <saved-collections-container></saved-collections-container>
  </div>
</template>

<script>
  import SavedCollectionsContainer from '@/components/saved-collections/SavedCollectionsContainer.vue'

  export default {
    name: 'SavedTables',
    components: { SavedCollectionsContainer }
  }
</script>
